
export default {
  name: 'SelfServices',
  components: {},
  mixins: [],
  props: [],
  asyncData: {},
  data() {
    return {
      services: [
        {
          title: this.$t('helpCenterPage.selfServices.services.title1'),
          icon: '$ForgetPass',
          route: !this.$cookies.get('accessToken') ? process.env.NUXT_APP_PANEL_BASE_URL + '/forget-password' : process.env.NUXT_APP_PANEL_BASE_URL + '/markets'
        },
        {
          title: this.$t('helpCenterPage.selfServices.services.title2'),
          icon: '$ChangePass',
          route: !this.$cookies.get('accessToken') ? process.env.NUXT_APP_PANEL_BASE_URL + '/login' : process.env.NUXT_APP_PANEL_BASE_URL + '/profile'
        },
        {
          title: this.$t('helpCenterPage.selfServices.services.title3'),
          icon: '$WithdrawPass',
          route: !this.$cookies.get('accessToken') ? process.env.NUXT_APP_PANEL_BASE_URL + '/login' : process.env.NUXT_APP_PANEL_BASE_URL + '/profile'
        },
        {
          title: this.$t('helpCenterPage.selfServices.services.title4'),
          icon: '$TwoFaPass',
          route: !this.$cookies.get('accessToken') ? process.env.NUXT_APP_PANEL_BASE_URL + '/login' : process.env.NUXT_APP_PANEL_BASE_URL + '/profile'
        },
        {
          title: this.$t('helpCenterPage.selfServices.services.title5'),
          icon: '$VerificationPass',
          route: !this.$cookies.get('accessToken') ? process.env.NUXT_APP_PANEL_BASE_URL + '/login' : process.env.NUXT_APP_PANEL_BASE_URL + '/profile'
        },
        {
          title: this.$t('helpCenterPage.selfServices.services.title6'),
          icon: '$CryptoDeposit',
          route: !this.$cookies.get('accessToken') ? process.env.NUXT_APP_PANEL_BASE_URL + '/login' : process.env.NUXT_APP_PANEL_BASE_URL + '/wallet'
        }
      ]
    }
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
